import axios from 'api/axios'
import { AdminUser } from 'types'
import handleAxiosError from 'utils/handleAxiosError'

/**
 * Type Interface of objects that can be used in the API for getAdmins
 */

export interface GetAdminsParams {
	page: number
	size: number
	query?: string
}

/**
 * Type Interface for the Response object you get from getAdmins request if successful
 */
export interface GetAdminsResponse {
	totalCount: number
	records: AdminUser[]
	totalPages: number
	currentPage: number
}

/**
 * API call to get Clients from the WhatCX Application
 * @param options GetAdminsParams - Options for the API call
 * @returns AdminResponse - Response object returned from the server
 */

export const getAdmins = async (options: GetAdminsParams) => {
	try {
		const { page = 1, size = 10, query = '' } = options
		const { data } = await axios.get<GetAdminsResponse>(
			`management/user?page=${page}&size=${size}&query=${query}`
		)

		return data
	} catch (error: any) {
		handleAxiosError(error)
		throw error
	}
}

export default getAdmins
